import { A11yModule } from "@angular/cdk/a11y";
import { LayoutModule } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { ExpansionPanelComponent } from "@hermes/aphrodite/expansion-panel";
import { CurrencyModule } from "@hermes/aphrodite/price";
import { PriceSliderComponent } from "@hermes/aphrodite/price-slider";
import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { SwitchButtonComponent } from "@hermes/aphrodite/switch-button";
import { FilterHatchService } from "@hermes/pages/grid-page";
import { GridFiltersStateModule } from "@hermes/states/grid-filters-state";
import { TrayStateModule } from "@hermes/states/tray";
import { GridFilterIdSetterPipeModule } from "@hermes/trays/grid-filters";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { SanitizePipeModule } from "@hermes/utils-generic/pipes/sanitize";

import { GridCheckboxComponent } from "./components/grid-checkbox/grid-checkbox.component";
import { GridDisplayModeComponent } from "./components/grid-display-mode/grid-display-mode.component";
import { GridFilterCheckboxComponent } from "./components/grid-filter-checkbox/grid-filter-checkbox.component";
import { GridFilterColorAndSizeComponent } from "./components/grid-filter-color-and-size/grid-filter-color-and-size.component";
import { GridFilterGroupComponent } from "./components/grid-filter-group/grid-filter-group.component";
import { GridFiltersBarComponent } from "./components/grid-filters-bar/grid-filters-bar.component";
import { GridFiltersCheckboxCrawlableComponent } from "./components/grid-filters-checkbox-crawlable/grid-filters-checkbox-crawlable.component";
import { GridFiltersClearComponent } from "./components/grid-filters-clear/grid-filters-clear.component";
import { GridFiltersMobileDialogComponent } from "./components/grid-filters-mobile-dialog/grid-filters-mobile-dialog.component";
import { GridFiltersResponsiveMenuComponent } from "./components/grid-filters-responsive-menu/grid-filters-responsive-menu.component";
import { GridFiltersSliderComponent } from "./components/grid-filters-slider/grid-filters-slider.component";
import { GridFiltersTagComponent } from "./components/grid-filters-tag/grid-filters-tag.component";
import { GridFiltersTagsComponent } from "./components/grid-filters-tags/grid-filters-tags.component";
import { GridSortComponent } from "./components/grid-sort/grid-sort.component";
import { GridToggleComponent } from "./components/grid-toggle/grid-toggle.component";

const COMPONENTS = [
    GridFiltersBarComponent,
    GridFiltersMobileDialogComponent,
    GridFiltersResponsiveMenuComponent,
    GridDisplayModeComponent,
    GridFiltersSliderComponent,
    GridFiltersCheckboxCrawlableComponent,
    GridFiltersClearComponent,
    GridFilterGroupComponent,
    GridSortComponent,
    GridFilterCheckboxComponent,
    GridFilterColorAndSizeComponent,
    GridCheckboxComponent,
    GridToggleComponent,
    GridFiltersTagsComponent,
    GridFiltersTagComponent,
];

@NgModule({
    declarations: [COMPONENTS],
    exports: COMPONENTS,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        A11yModule,
        CallToActionComponent,
        LayoutModule,
        CurrencyModule,
        RouterModule,
        SvgIconComponent,
        ExpansionPanelComponent,
        TrayStateModule,
        GridFiltersStateModule,
        SanitizePipeModule,
        GridFilterIdSetterPipeModule,
        PriceSliderComponent,
        SwitchButtonComponent,
        SrOnlyNoSnippetDirective,
    ],
    providers: [FilterHatchService],
})
export class GridFiltersModule {}
